module.exports = __webpack_public_path__ + "static/img/practiceSystem_05.14b6f8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/practiceSystem_05.png
// module id = WjjI
// module chunks = 23